export default __webpack_public_path__ + "static/media/darkSeatBelt.780e8127.png";